// @flow
import styled, { type StyledComponent } from 'styled-components'
import React, { Component } from 'react'
import type { Size, Crop } from './types'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
  overflow: hidden;

  border-radius: ${({ isRounded }: Object) => (isRounded ? '50%' : '')};
  display: ${({ block }: Object) => (block ? 'block' : 'inline-block')};
  float: ${({ float }: Object) => (float ? 'left' : 'none')};
`

const Image: StyledComponent<Object, any, any> = styled.img`
  position: absolute;
`

const DEFAULT_HEIGHT = 100

export type Props = {|
  imageSrc: string,
  size: Size,
  crop?: ?Crop,
  width?: number,
  height?: number,
  block?: boolean,
  float?: boolean,
  isRounded?: boolean,
  isCover?: boolean, // ignore crop and cover by center
  isContains?: boolean // component size limited by width and height
|}

export default class ImagePreview extends Component<Props> {
  render() {
    const { block, float, imageSrc, isRounded } = this.props
    return (
      <Wrapper float={float} block={block} isRounded={isRounded} style={this.containerStyle()}>
        <Image src={imageSrc} style={this.imageStyle()} />
      </Wrapper>
    )
  }

  containerStyle() {
    const { width, height = DEFAULT_HEIGHT, isContains, size } = this.props
    const crop = this.calculatedCrop()

    const isWidthBased = isContains && width ? width * size.height <= height * size.width : !!width

    return isWidthBased && width
      ? {
          width: width,
          height: width * (crop.height / crop.width)
        }
      : {
          width: height * (crop.width / crop.height),
          height: height
        }
  }

  coverCrop() {
    const { width, height, size } = this.props

    if (!width || !height) return this.defaultCrop()

    const horizontalCut = width * size.height <= height * size.width

    if (horizontalCut) {
      const zoom = height / size.height
      const cropWidth = width / zoom
      const offset = (size.width - cropWidth) / 2

      return { x: offset, y: 0, width: cropWidth, height: size.height }
    } else {
      const zoom = width / size.width
      const cropHeight = height / zoom
      const offset = (size.height - cropHeight) / 2

      return { x: 0, y: offset, width: size.width, height: cropHeight }
    }
  }

  imageStyle() {
    const { size, width, height = DEFAULT_HEIGHT } = this.props

    const calculatedCrop = this.calculatedCrop()
    const zoom = width ? width / calculatedCrop.width : height / calculatedCrop.height

    return {
      left: -calculatedCrop.x * zoom,
      top: -calculatedCrop.y * zoom,
      width: size.width * zoom,
      height: size.height * zoom
    }
  }

  calculatedCrop() {
    const { isCover, crop } = this.props
    return isCover ? this.coverCrop() : crop || this.defaultCrop()
  }

  defaultCrop(): Crop {
    const { width, height } = this.props.size
    return { x: 0, y: 0, width, height }
  }
}
